import { HvButton, HvPanel, HvStack, HvTab, HvTabs, HvTypography, HvGrid, HvTag, HvOverflowTooltip, HvLabel } from '@hitachivantara/uikit-react-core';
import React, { useEffect, useState, useRef } from 'react';
import { PlayVideoScreen, Backwards, Time, Layers, Calendar, Tag, Host } from "@hitachivantara/uikit-react-icons";
import { LOGGED_IN_USER_INFO, VIRTUAL_HARDWARE, PHYSICAL_HARDWARE } from "constants/common";
import { Box } from '@mui/material';
import LabService from 'services/LabService';
import { buildQueryParams } from 'utils/common';
import ScPortal from 'components/newScPortal/ScPortal';
import _ from 'lodash';
import Resource from './Resource';
import { showLoader } from "redux/actions/commonActions";
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { LAB_AS_A_SERVICE, LAB_ON_DEMAND_MESSAGE, LAB_SERVICE_MESSAGE, ON_DEMAND_LAB, PREP_LAB_ONDEMAND } from 'constants/labs';
import FileUploadService from 'services/FileUploadService';
import { OKTA_TOKEN_INFO } from 'constants/common';
import { showBanner } from 'redux/actions/bannerActions';
import AgreementDialog from 'components/agreementDialog/AgreementDialog';

const fileUploadServiceObj = new FileUploadService();

const LabDetailView = ({ history }) => {
    const labServiceObj = new LabService();
    const dispatch = useDispatch();
    const { location } = history;
    const state = location && location?.state;
    const labId = state?.labId ? state?.labId : location?.search?.split("=")[1]
    const [tabsName] = useState(['Overview', 'Resources']);
    const [labDetail, setLabDetail] = useState()
    const [value, setValue] = useState(0);
    const [runningLabData, setRunningLabData] = useState();
    const [showSCPortal, setShowSCPortal] = useState(false);
    const [resourceData, setResourceData] = useState([]);
    const [activeSession, setActiveSession] = useState([]);
    const [openAgreementDialog, setOpenAgreementDialog] = useState(false);
    const [acceptAggreement, setAcceptedAgreement] = useState(false);
    const handleChange = (e, newValue) => setValue(newValue);
    const containerRef = useRef(null);

    let data = sessionStorage.getItem(LOGGED_IN_USER_INFO);
    let token = data ? JSON.parse(data) : {}
    let urlParams = {};
    let oktaUserInfo = JSON.parse(localStorage.getItem(OKTA_TOKEN_INFO))
    useEffect(() => {
        containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!_.isUndefined(labId)) {
            getLabDetailsByURLId();
        }
    }, [labId]);

    const getLabDetailsByURLId = () => {
        let browserURL = window.location.href;
        if (labId && (browserURL.search("labId") < 0 || (token?.access_token) || oktaUserInfo?.accessToken?.accessToken)) {
            localStorage.setItem("LabUrl", '/labdetailview/?labId=' + labId)
            urlParams["object_id"] = labId;
            fileUploadServiceObj.getResourceUrlByLabId(buildQueryParams(urlParams)).then(response => {
                if (response) {
                    const { results } = response;
                    if (results && results.length > 0) {
                        setResourceData(results)
                    }
                }
            }).catch(error => {
                dispatch(showBanner({
                    payload: {
                        showBanner: true,
                        label: { message: "Error while getting resource." },
                        variant: "error"
                    }
                }))
            })
            labServiceObj.getLabDetailsById(labId).then(response => {
                if (response) {
                    setLabDetail(response);
                    if (response?.session.length > 0) {
                        setActiveSession(response.session[0]);
                    }
                    localStorage.removeItem("LabUrl");
                }
            }).catch(error => {
                dispatch(showBanner({
                    payload: {
                        showBanner: true,
                        label: { message: "Error while getting Lab details. Please contact Administrator." },
                        variant: "error"
                    }
                }))
                history.push("/labs");
            })
        } else {
            if ((_.isEmpty(token?.access_token) && _.isEmpty(oktaUserInfo?.accessToken?.accessToken))) {
                localStorage.setItem("LabUrl", '/labdetailview/?labId=' + labId)
                history.push("/");
            } else {
                if (browserURL.search("labId") > 0) {
                    localStorage.setItem("LabUrl", '/labdetailview/?labId=' + labId)
                }
            }
        }

    }



    const redirect = (url, labData) => {
        history.push(
            {
                pathname: url,
                state: {
                    labDetail: labData
                }
            }
        );
    }



    const displayTabs = tabsName.map((tab, index) => {
        return (
            <>
                <HvTab id={index} label={tab} value={index} onChange={handleChange} />
            </>
        )
    })



    const renderContainer = (id, children) => (
        <>
            <HvTypography id={id}>
                <div dangerouslySetInnerHTML={{ __html: children || "" }} />
            </HvTypography>
        </>
    )



    const renderLabButton = (lab) => {
        switch (lab?.tag_description?.replaceAll(" ", "").toUpperCase()) {
            case ON_DEMAND_LAB:
                return (
                    !_.isEmpty(activeSession) ?
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab() }}><PlayVideoScreen />View Lab</HvButton>
                        </Box> :
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab() }}><PlayVideoScreen />Run Lab</HvButton> :
                        </Box>
                )
            case PREP_LAB_ONDEMAND:
                return (
                    !_.isEmpty(activeSession) ?
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab(true) }}><PlayVideoScreen />View Lab</HvButton>
                        </Box> :
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab(true) }}><PlayVideoScreen />Run Lab</HvButton> 
                        </Box>
                )
            case LAB_AS_A_SERVICE:
                return (!_.isEmpty(activeSession) ?
                    <Box component={'div'} alignSelf={'center'}>
                        <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab() }}><PlayVideoScreen />View Lab</HvButton>
                    </Box> :
                    <HvButton category="primary" onClick={() => { redirect('/labscheduler', lab) }}><Calendar />Schedule</HvButton>
                )
            default:
                return (
                    !_.isEmpty(activeSession) ?
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab() }}><PlayVideoScreen />View Lab</HvButton>
                        </Box> :
                        <Box component={'div'} alignSelf={'center'}>
                            <HvButton category="primary" onClick={() => { fetchRedirectionUrlForLab() }}><PlayVideoScreen />Run Lab</HvButton> 
                        </Box>
                )
        }
    }

    const renderLabTagType =(lab)=>{
        switch (lab?.tag_description?.replaceAll(" ", "").toUpperCase()) {
            case ON_DEMAND_LAB:
                return(
                    <Box component="div" display='flex' width='55%'>
                            <Host iconSize='XS' />
                            <HvTypography style={{ alignSelf: 'center' }}>{VIRTUAL_HARDWARE}</HvTypography>
                        </Box> 
                )
            case PREP_LAB_ONDEMAND:
                return(
                    <Box component="div" display='flex' width='55%'>
                            <Host  iconSize='XS'/>
                            <HvTypography style={{ alignSelf: 'center' }}>{VIRTUAL_HARDWARE}</HvTypography>
                        </Box> 
                )
            case LAB_AS_A_SERVICE:
                return(
                    <Box component="div" display='flex' width='55%'>
                            <Host iconSize='XS'/>
                            <HvTypography style={{ alignSelf: 'center' }}>{PHYSICAL_HARDWARE}</HvTypography>
                        </Box> 
                )
        
            default:
                return(
                    <Box component="div" display='flex' width='55%'>
                            <Host iconSize='XS' />
                            <HvTypography style={{ alignSelf: 'center' }}>{VIRTUAL_HARDWARE}</HvTypography>
                        </Box> 
                )
        }
    }

    const fetchRedirectionUrlForLab = (value) => {
        const data = sessionStorage.getItem(LOGGED_IN_USER_INFO);
        const token = data ? JSON.parse(data) : {}
        const urlParams = { lab_id: labDetail?.id }
        let finalData = {};
        if(labDetail?.tag_description?.replaceAll(" ", "").toUpperCase() === PREP_LAB_ONDEMAND &&  value === false) {
            setOpenAgreementDialog(!openAgreementDialog);
        }else{
            if (token?.access_token) {
                if (!_.isEmpty(activeSession)) {
                    let data = {
                        id: activeSession?.id,
                        url: activeSession?.url,
                        labId: labDetail?.id,
                        labName: labDetail?.name
                    }
                    dispatch(showLoader(true))
                    labServiceObj.getInstruction(buildQueryParams(urlParams)).then(response => {
                        setShowSCPortal(!showSCPortal)
                        if (response) {
                            dispatch(showLoader(false))
                            finalData = {
                                ...data,
                                instruction: response?.data.results[0]?.instruction_file,
                                video_instruction: response?.data.results[0]?.video_instruction
                            }
                        }
                        redirect('/scportal', finalData);
                        const labData = [];
                        labData.push(finalData);
                    })
                } else {
                    const payload = { "lab": labDetail?.id };
                    dispatch(showLoader(true))
                    labServiceObj.activateLabUrl(payload).then(response => {
                        if (response && (response.url !== '' && response.url !== null)) {
                            let data = {
                                url: response.url,
                                labId: labDetail?.id,
                                labName: labDetail?.name,
                                id: response.id
                            }
                            labServiceObj.getInstruction(buildQueryParams(urlParams)).then(response => {
                                setShowSCPortal(!showSCPortal)
                                if (response) {
                                    dispatch(showLoader(false))
                                    finalData = {
                                        ...data,
                                        instruction: response?.data.results[0]?.instruction_file,
                                        video_instruction: response?.data.results[0]?.video_instruction
                                    }
                                }
                                redirect('/scportal', finalData);
                                const labData = [];
                                labData.push(finalData);
                            })
                            setRunningLabData(finalData)
                        }
                    })
                        .catch(() => {
                            dispatch(showBanner({
                                payload: {
                                    showBanner: true,
                                    label: { message: "Error while running the lab." },
                                    variant: "error"
                                }
                            }))
                        });
                }
    
            } else {
                redirect('/')
            }
        }
        
    }
    const calCulateHourAndTime = (labTime) => {
        const hours = Math.floor(labTime / 60);
        const minutes = labTime % 60;
        return minutes > 0 ? `${hours}hrs and ${minutes}mins.` : `${hours}hrs.`

    }

const renderSubeHeader = (tagDescription) =>{
    switch (tagDescription?.replaceAll(" ", "").toUpperCase()) {
        case ON_DEMAND_LAB:
           return(<HvTypography variant='selectedNavText' style={{ display: "flex", padding: "10px" }} >{LAB_ON_DEMAND_MESSAGE}</HvTypography>)
        
        case LAB_AS_A_SERVICE:
            return(<HvTypography variant='selectedNavText' style={{ display: "flex", padding: "10px" }} >{LAB_SERVICE_MESSAGE}</HvTypography>)

        case PREP_LAB_ONDEMAND:
            return(<HvTypography variant='selectedNavText' style={{ display: "flex", padding: "10px" }} >PREP LAB : {LAB_ON_DEMAND_MESSAGE}</HvTypography>)
        default:
            return(<HvTypography variant='selectedNavText' style={{ display: "flex", padding: "10px" }} >{LAB_ON_DEMAND_MESSAGE}</HvTypography>)
    }
}
    return (
        <div ref={containerRef}>
            {
                showSCPortal ?
                    <ScPortal data={runningLabData} /> :
                    <HvStack style={{ paddingTop: "10px" }} ref={containerRef}>
                        <HvPanel >
                            <HvGrid container={true}>
                                <HvGrid item xs={4} sm={8} md={8} lg={6} xl={12}>
                                    <Box>
                                        <HvTypography variant='mTitle' style={{ display: "flex" }}> <Backwards onClick={() => { history?.push("/labs") }} style={{ cursor: "pointer" }} />{labDetail?.name}</HvTypography>
                                      {renderSubeHeader(labDetail?.tag_description)}
                                    </Box>
                                </HvGrid>
                                <HvGrid item xs={6} sm={4} md={6} lg={4} xl={6}>
                                    <Box component={'div'} columnGap={2} >
                                        {
                                            labDetail?.max_lab_time ?
                                                <Box component={'div'} display={'flex'} alignSelf={'center'} >
                                                    <Time />
                                                    <HvTypography style={{ alignSelf: 'center' }}>{labDetail?.max_lab_time && !_.isNull(labDetail?.max_lab_time) ? (labDetail?.max_lab_time < 60 ? `${labDetail.max_lab_time} minutes` : calCulateHourAndTime(labDetail?.max_lab_time)) : 'NA'}</HvTypography>
                                                </Box> : <Box component={'div'} display={'flex'} alignSelf={'center'} >
                                                    <Time />
                                                    <HvTypography style={{ alignSelf: 'center' }}>{"Self Paced"}</HvTypography>
                                                </Box>
                                        }
                                    </Box>
                                    <Box component={'div'} display={'flex'} alignSelf={'center'}  >
                                        <Layers />
                                        <HvTypography style={{ alignSelf: 'center' }}>{labDetail?.categories.toString()}</HvTypography>
                                    </Box>
                                    <Box component={'div'} display={'flex'} alignSelf={'center'} style={{ flexWrap: "wrap" }}>
                                        {labDetail?.labtags && labDetail?.labtags.length > 0 ?
                                            <>

                                                <Tag iconSize="XS" />
                                                {
                                                    labDetail?.labtags.map((t1) => (
                                                        <>
                                                            <HvTag label={t1.length > 4 ? <HvOverflowTooltip data={t1}></HvOverflowTooltip> : t1} type="categorical" color={_.sample(["cviz1", "cviz2", "cviz3", "cviz4", "cviz5"])} style={{ alignSelf: 'center' }} />
                                                        </>
                                                    ))
                                                }

                                            </>

                                            :
                                            <></>}
                                    </Box>
                                    <Box component="div" display='flex' >
                                        {
                                            renderLabTagType(labDetail)
                                        }

                                    </Box>

                                </HvGrid>
                                <HvGrid item xs={4} sm={4} md={4} lg={2} xl={6} ref={containerRef} >
                                    {
                                        renderLabButton(labDetail)

                                    }

                                </HvGrid>
                            </HvGrid>
                        </HvPanel>
                        <HvPanel>
                            <HvTabs id='tabs-main' value={value} onChange={handleChange} variant='fullWidth'>
                                {displayTabs}
                            </HvTabs>
                        </HvPanel>
                        <HvPanel style={{ height: '100%' }}>
                            {value === 0 && renderContainer("overview", labDetail?.description)}
                            {value === 1 && <><Resource resourceData={resourceData} objectId={labId} /></>}
                        </HvPanel>
                    </HvStack>

            }
            {
                openAgreementDialog ? <AgreementDialog launchOrScheduleLab={(value) => {
                    setAcceptedAgreement(value) 
                    fetchRedirectionUrlForLab(value) }} openAgreementDialog={(value) => { setOpenAgreementDialog(value) }} /> : <></>
            }
        </div>
    );
};



export default withRouter(LabDetailView);